<app-warehouse-product-purchase-add
  [warehouseProductObject]="warehouseProductObject"
  [dialogRef]="dialogRef"
>
</app-warehouse-product-purchase-add>
